
import { AppUsuarioService } from '../../../core/services/appUsuarioService.service';
import { Component, EventEmitter, OnInit, Output, Input, Inject, AfterViewInit, SimpleChanges } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MessageDialog } from '../../../components/message-dialog/messageDialog';
import { ListFormBase } from '../../../core/helper/ListFormBase';
import { MatDialog } from '@angular/material/dialog';
import { DocsUsersDialogComponent } from '../../docs-users-dialog/docs-users-dialog.component';
import { Renderer2 } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { AppUsersDocs } from '../../../core/models/appUsersDocs.model';
import { ViewChild } from '@angular/core';
import { DxDataGridComponent } from 'devextreme-angular';
import { formatDate } from '../../../livesHrComponentes/helpers/getLocalDate.js'

@Component({
  selector: 'app-documentos-usuarios-list',
  templateUrl: './documentos-usuarios-list.component.html',
  styleUrls: ['./documentos-usuarios-list.component.scss'],
  providers: [AppUsuarioService]
})
export class DocumentosUsuariosListComponent extends ListFormBase<AppUsersDocs> implements AfterViewInit {

  @Input() subjectID: string;
  @Input() company: string;
  @Input() documentReaders: {};
  @Output() selectedUsers = new EventEmitter<string>();
  @Output() deleteUsers = new EventEmitter<string>();
  @Input() usersSelectedNif: string[];
  usersSelected: string[];
  docId: string;

  @ViewChild(DxDataGridComponent, { static: false }) dataGrid: DxDataGridComponent;

  exporting = false;

  constructor(
    protected _modelService: AppUsuarioService,
    protected _router: Router,
    protected _route: ActivatedRoute,
    protected _messageDialog: MessageDialog,
    protected _docsUsersPopUp: MatDialog,
    private renderer: Renderer2,
    protected userService: AppUsuarioService,
    @Inject(DOCUMENT) private document: Document
  ) {
    super(_modelService, _router, _route, _messageDialog, AppUsersDocs);
    this.isCrud = false;
    this.usersSelected = [];
  }



  ngAfterViewInit(): void {
    setTimeout(() => {
      this.getUsersSelected()

    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.usersSelectedNif && !changes.usersSelectedNif.firstChange) {
      this.getUsersSelected();
      if (this.dataGrid) {
        this.dataGrid.instance.endCustomLoading();  // Detener el estado de carga
      }
    }
  }

  getUrlId(): string {
    var url = this._router.url.split('/');
    return url[url.length - 1]
  }

  calculateWorkerName(rowData) {
    return rowData.name + ' ' + rowData.surnames;
  }

  getUsersSelected() {
    this.userService.getAllForSelectByCompanyNif(this.company).subscribe(
      data => {
        if (data.length > 0) {
          this.dataSource = data.filter(user => this.usersSelectedNif.includes(user.nif)).map(user => {
            const reader = this.documentReaders[user.user1];
            if (reader) {
              user.viewedAt = formatDate(reader.viewedAt);
            } else {
              user.viewedAt = ''
            }
            return user;
          });
        }
      },
      error => {
        console.error('error al obtener usuarios por empresa:', error);
      }
    );
  }


  onToolbarPreparing(e) {

    e.toolbarOptions.items.unshift({
      location: 'after',
      template: 'addNew'
    });


    const toolbarItems = e.toolbarOptions.items;
    toolbarItems.forEach(element => {
      if (element.name === 'addRowButton') {
        // Importante, hay que hacer un bind para indicarlo cual es el "this" que debe usar.
        element.options.onClick = this.openNew();
      }
    });
  }

  openNew() {
    const dialogRef = this._docsUsersPopUp.open(DocsUsersDialogComponent, {
      width: '95%',
      data: { subjectID: this.subjectID, company: this.company, type: 'User', data: this.dataSource },

    });

    const dialogContainer = this.document.querySelector('.mat-dialog-container');
    if (dialogContainer) {
      this.renderer.setStyle(dialogContainer, 'background-color', '#e8e8e8');
    }

    dialogRef.afterClosed().subscribe(result => {
      // this.dataSource = result;
      this.dataGrid.instance.beginCustomLoading('');
      this.selectedUsers.emit(result);
    });


  }


  onDeleteRelation(data: any) {

    this._messageDialog.ShowQuestion(

      `Se desvinculará a ${data.name} ${data.surnames} del documento`,
      'Desvincular empleado del documento'
    )
      .then(result => {
        if (result.value) {
          this.deleteUsers.emit(data);

          this.dataGrid.instance.beginCustomLoading('');
        }
      });
  }

  onExporting(e) {
    this.exporting = true;
    setTimeout(() => { this.exporting = false; }, 300);
  }


}
